module.exports = __webpack_public_path__ + "Roboto-Regular.ca03724997d958c9d232.woff";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Regular.woff
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Regular.woff
// module chunks = styles